const e = e => e.trim().toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, ((e, a) => a.toUpperCase()));

export { e as default };
//# sourceMappingURL=index.js.map
